import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { CenterResponseType, Data } from "../types/centerResponse";
import { CenterPayloadType } from "../types/centerRequest";

export const centerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCenters: builder.query<
      ApiResponseType<Data>,
      { size?: number; page?: number; search?: string; zone?: string; district?: string; type?: string; sort_by?: string; sort_order?: string }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.zone) queryParams.append("zone", params.zone);
        if (params?.district) queryParams.append("district", params.district);
        // if (params?.status) queryParams.append("status", params.status);
        if (params?.type) queryParams.append("type", params.type);
        if (params?.sort_by) queryParams.append("sort_by", params.sort_by);
        if (params?.sort_order) queryParams.append("sort_order", params.sort_order);


        return `centers/get-all?${queryParams.toString()}`;
      },
      providesTags: ["Centers"],
    }),
    getCenterList: builder.query<
      ApiResponseType<{ items: Array<{ id: number; name: string }>; pageSize?: number; currentPage?: number; totalItems?: number; totalPages?: number; }>,
      void
    >({
      query: () => "centers/list",
      providesTags: ["Centers"],
    }),
    addCenter: builder.mutation<
      ApiResponseType<{ center: CenterResponseType }>,
      CenterPayloadType
    >({
      query: (payload) => ({
        url: "centers/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Centers"],
    }),
    getCenterById: builder.query<
      ApiResponseType<{ center: CenterResponseType }>,
      { id: string }
    >({
      query: ({ id }) => `centers/get/${id}`,
      providesTags: (result) => [
        { type: "Centers", id: result?.data.center.id },
      ],
    }),
    updateCenter: builder.mutation<
      ApiResponseType<{ center: CenterResponseType }>,
      { id: string; payload: Partial<CenterPayloadType> }
    >({
      query: ({ id, payload }) => ({
        url: `centers/update/${id}`,
        method: "PUT",
        body: { ...payload },
      }),
      invalidatesTags: ["Centers"],
    }),
    deleteCenter: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `centers/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Centers"],
    }),
    uploadCenterPhoto: builder.mutation<
      ApiResponseType<{ file_name: string; file_url: string }>,
      { id: string; image: File }
    >({
      query: ({ id, image }) => {
        const formData = new FormData();
        formData.append("image", image);
        return {
          url: `centers/upload-photo/${id}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Centers", id }],
    }),
    uploadCenterDocs: builder.mutation<
      ApiResponseType<{ file_name: string; file_url: string }>,
      { id: string; docType: "icard" | "address_proof"; file: File }
    >({
      query: ({ id, docType, file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `centers/upload-registration-docs/${docType}/${id}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Centers", id }],
    }),
  }),
});

export const {
  useGetAllCentersQuery,
  useAddCenterMutation,
  useGetCenterByIdQuery,
  useUpdateCenterMutation,
  useDeleteCenterMutation,
  useUploadCenterPhotoMutation,
  useUploadCenterDocsMutation,
  useGetCenterListQuery,
} = centerApi;
